import { Checkbox as MuiCheckbox, styled } from '@mui/material';

/**
 * The selection checkbox over a grid card's thumbnail. Its container reveals it on hover,
 * selection and focus.
 */
export const GridCheckbox = styled(MuiCheckbox)(({ theme }) => ({
  opacity: 0,
  color: theme.palette.common.white,
  position: 'absolute',
  zIndex: 1,
  '&.Mui-checked': {
    color: theme.palette.common.white,
  },
  // It sits on the thumbnail image
  '&.Mui-focusVisible': theme.mixins.focusRingOnImage,
}));
